import { __decorate } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import SubmitPreview from "./SubmitPreview.vue";
import SubmitConfig from "./SubmitConfig.vue";
import { mixins } from "vue-class-component";
import commonMixin from "@/mixins/commonNewMixins";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore/newIndex";
let questionnaireSubmitSet = class questionnaireSubmitSet extends mixins(commonMixin) {
  get basicData() {
    return QuestionnaireEditModule.basicData;
  }
  get questionnaireType() {
    return QuestionnaireEditModule.questionnaireType;
  }
  getModulesConfigInstance() {
    return this.$refs.modulesConfig;
  }
  async CHECK_DATA_validate() {
    try {
      let result = await this.getModulesConfigInstance().validate();
      // if (result.valid) {
      //   let totalScore = 0;
      //   this.dataList.forEach((element: any) => {
      //     totalScore += Number(element.data.itemScore) || 0;
      //   });
      //   QuestionnaireEditModule.SET_TOTALSCORE_DATA(totalScore as number);
      // }
      return result;
    } catch (error) {
      console.log("CHECK_DATA_validateerror", error);
      return false;
    }
  }
};
__decorate([Prop({
  type: String,
  default: "ACTIVITY"
})], questionnaireSubmitSet.prototype, "type", void 0);
questionnaireSubmitSet = __decorate([Component({
  name: "questionnaireSubmitSet",
  components: {
    SubmitPreview,
    SubmitConfig
  },
  filters: {}
})], questionnaireSubmitSet);
export default questionnaireSubmitSet;